import { Component, Watch, Vue, Prop } from 'vue-property-decorator';
import * as services from './services';

@Component
export default class PaymentGatewayWrapper extends Vue {
    @Prop() public variant?: number;

    public failed = false;
    public failedReinitAttempts = 0;
    public loading = true;
    public loadingCounter = 0;
    public cardElementsPrepared: string[] = [];

    public form: {
        creditCard: any,
        cvc: any,
        expiry: any,
    } = {
        creditCard: {
            value: '',
            isEmpty: true,
        },
        cvc: {
            value: '',
            isEmpty: true,
        },
        expiry: {
            value: '',
            isEmpty: true,
        },
    };

    public styleVariant: number = 0;

    // idk how to implement in typescript
    public Integration: any = {};

    protected wasLoaded: boolean = false;

    public setStyleVariant(variant: number) {
        this.styleVariant = variant;
    }

    public validate(hard?: boolean) {
        const validation = this.Integration.validate(hard);
        this.$emit('validation', validation);
        return validation;
    }

    public clearData() {
        this.Integration.clearData();
    }

    public async serialize(additionals: any, callback: any) {
        const serializedData = await this.Integration.serialize(additionals)
            .catch((e: any) => e);
        if (callback) {
            callback(serializedData, serializedData.isValid === false);
        }
        return serializedData;
    }

    public forceCreditCardInput(value) {
        this.$emit('creditCardForceInput', value);
    }

    public forceExpiryInput(value) {
        this.$emit('ExpiryForceInput', value);
    }

    public forceCVCInput(value) {
        this.$emit('CVCForceInput', value);
    }

    public retryInitIntegration() {
        this.wasLoaded = false;
        // TODO should we reinstall here?
        this.Integration.created().then(() => {
            this.cardElementsPrepared = [];
            this.loadingCounter = 0;
            this.failed = false;
        });
    }

    public mounted() {
        // idk why - not working sync
        setTimeout(() => {
            this.$emit('didMount', true) ;
        });
    }

    public countCardElements(cardType: string) {
        if (!this.wasLoaded && !this.cardElementsPrepared.includes(cardType)) {
            this.cardElementsPrepared.push(cardType);
        }
    }

    private render(createElement: any) {
        if (!this.failed && !this.loading) {
            services.prepareSlots(this, createElement, undefined);
            if (this.$slots.default && this.loadingCounter !== this.cardElementsPrepared.length) {
                return createElement(
                    'div',
                    this.$slots.default.concat([createElement(this.Integration.loadingComponent)]),
                );
            } else if (this.$slots.default) {
                return createElement('div', this.$slots.default);
            }
        } else if (this.failed) {
            return createElement(this.Integration.errorComponent);
        } else if (this.loading) {
            return createElement(this.Integration.loadingComponent);
        }
    }

    private async created() {
        try {
            await this.initIntegration();
            if (this.variant) {
                this.styleVariant = this.variant;
            }
        } catch (e) {
            // tslint:disable-next-line
            console.error('PaymentGateway invalid integration');
            // tslint:disable-next-line
            console.error(e);
            this.failed = true;
        }
    }

    private async initIntegration() {
        // @ts-ignore
        this.install();
        // @ts-ignore
        await this.preInit();
        await this.Integration.created();
    }

    private updated() {
        if (!this.loading && !this.wasLoaded) {
            this.wasLoaded = true;
            this.$emit('loaded');
        }
    }

    @Watch('failed')
    private onFailed(val) {
        if (val) {
            console.error('PaymentGateway: something failed');
            this.failedReinitAttempts += 1;
        }
    }

    @Watch('Integration')
    private onIntegration() {
        this.$forceUpdate();
    }

    @Watch('form', { deep: true })
    private onForm() {
        const validation = this.Integration.validate();
        this.$emit('ready', validation.isValid);
    }
}
